import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiPaths } from '../_enums/api-paths';

const httpOptions = {
  headers: new HttpHeaders({ 'Accept': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class ContractorService { 
  baseUrl = environment.baseUrl;
  
  constructor(
    private router: Router, 
    private http: HttpClient, 
  ) { }

  getContractorsList$(uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.contractors}`;
    return this.http.get<any>(url + 'list?uuid=' + uuid);
  }

  getContractor$(contractorId: number, uuid: string): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.contractors}`;
    return this.http.get<any>(url + '?contractor_id=' + contractorId + '&uuid=' + uuid);
  }

  addContractor$(uuid: string, contractorInfo: any): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.contractors}`;
    return this.http.post<any>(url + '?uuid=' + uuid, contractorInfo, httpOptions);
  }

  updateContractor$(uuid: string, contractorInfo: any): Observable<any> {
    let url = `${this.baseUrl}/${ApiPaths.contractors}`;
    return this.http.put<any>(url + '?uuid=' + uuid, contractorInfo, httpOptions);
  }
}